<template>
  <CommonNoticeCard
    :class="[b()]"
  >
    <div
      slot="content"
      :class="b('content')"
      v-html="content"
    />
    <template #actions>
      <el-button
        type="plaintext2"
        @click.stop="gotoDashboard"
      >
        <em :class="['zkicon iconxianshi']" />
        {{ $t('button.view') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';

export default {
  name: 'KanbanDashboardSaveCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    content() {
      return this.$t('notice.kanban.save.dashboard', {
        kanban: `<span class="${this.b('name')}">${this.data.kanbanName}</span>`,
        dashboard: `<span class="${this.b('name')}">${this.data.dashboardName}</span>`
      });
    }
  },
  methods: {
    gotoDashboard() {
      console.log('[ this ]-54', this);
      this.microRouter.push({ name: 'dashboard' });
    }
  }
};
</script>

<style lang="scss">
@include b(kanban-dashboard-save-card) {
  @include e(name)  {
    color: var(--font-color-1);
    font-weight: var(--weight-font-Blod);
    margin: 0 4px;
  }
}
</style>
